import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b10ba54"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "sc-upload__uploading"
};
const _hoisted_2 = {
  class: "sc-upload__progress"
};
const _hoisted_3 = {
  key: 1,
  class: "sc-upload__img"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sc-upload__img-slot"
}, " Loading... ", -1));
const _hoisted_5 = {
  key: 0,
  class: "sc-upload__img-actions"
};
const _hoisted_6 = {
  class: "el-upload--picture-card"
};
const _hoisted_7 = {
  class: "file-empty"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  style: {
    "display": "none!important"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_icon_delete = _resolveComponent("el-icon-delete");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_input = _resolveComponent("el-input");
  const _component_sc_cropper = _resolveComponent("sc-cropper");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sc-upload", {
      'sc-upload-round': $props.round
    }]),
    style: _normalizeStyle($data.style)
  }, [$data.file && $data.file.status != 'success' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_progress, {
    percentage: $data.file.percentage,
    "text-inside": true,
    "stroke-width": 16
  }, null, 8, ["percentage"])]), _createVNode(_component_el_image, {
    class: "image",
    src: $data.file.tempFile,
    fit: "cover"
  }, null, 8, ["src"])])) : _createCommentVNode("", true), $data.file && $data.file.status == 'success' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_image, {
    class: "image",
    src: $data.file.url,
    "preview-src-list": [$data.file.url],
    fit: "cover",
    "hide-on-click-modal": "",
    "append-to-body": "",
    "z-index": 9999
  }, {
    placeholder: _withCtx(() => [_hoisted_4]),
    _: 1
  }, 8, ["src", "preview-src-list"]), !$props.disabled ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", {
    class: "del",
    onClick: _cache[0] || (_cache[0] = $event => $options.handleRemove())
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_el_icon_delete)]),
    _: 1
  })])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !$data.file ? (_openBlock(), _createBlock(_component_el_upload, {
    key: 2,
    class: "uploader",
    ref: "uploader",
    "auto-upload": $props.cropper ? false : $props.autoUpload,
    disabled: $props.disabled,
    "show-file-list": $props.showFileList,
    action: $props.action,
    name: $props.name,
    data: $props.data,
    accept: $props.accept,
    limit: 1,
    "http-request": $options.request,
    "on-change": $options.change,
    "before-upload": $options.before,
    "on-success": $options.success,
    "on-error": $options.error,
    "on-exceed": $options.handleExceed
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent($props.icon)))]),
      _: 1
    }), $props.title ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString($props.title), 1)) : _createCommentVNode("", true)])])], true)]),
    _: 3
  }, 8, ["auto-upload", "disabled", "show-file-list", "action", "name", "data", "accept", "http-request", "on-change", "before-upload", "on-success", "on-error", "on-exceed"])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_9, [_createVNode(_component_el_input, {
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.value = $event)
  }, null, 8, ["modelValue"])]), _createVNode(_component_el_dialog, {
    title: "剪裁",
    draggable: "",
    modelValue: $data.cropperDialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.cropperDialogVisible = $event),
    width: 580,
    onClosed: $options.cropperClosed,
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = $event => $data.cropperDialogVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取 消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.cropperSave
    }, {
      default: _withCtx(() => [_createTextVNode("确 定")]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createVNode(_component_sc_cropper, {
      src: $data.cropperFile.tempCropperFile,
      compress: $props.compress,
      aspectRatio: $props.aspectRatio,
      ref: "cropper"
    }, null, 8, ["src", "compress", "aspectRatio"])]),
    _: 1
  }, 8, ["modelValue", "onClosed"])], 6);
}